export enum FirestoreEnum {
  APP_KEY_CONFIGS = 'appKeyConfigs',
  BATCHMAN = 'batch-fwk',
}

export enum FirestoreValuesEnum {
  NO_GROUP = 'NO GROUP',
}
